import { useMemo } from 'react';
import Head from 'next/head';

const JsonLdSchema = () => {
  const schemas = useMemo(() => {
    const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': ['Airline', 'Organization'],
    '@id': 'https://www.allegiantair.com/#organization',
    name: 'Allegiant Air',
    alternateName: ['Allegiant', 'Allegiant Travel Company'],
    url: 'https://www.allegiantair.com/',
    legalName: 'Allegiant Air, LLC',
    description:
      'Allegiant Air is a low-cost airline that connects small and medium cities to popular leisure destinations across the United States.',
    logo: 'https://www.allegiantair.com/content/dam/allegiant/images/logos/allegiant-logo-blue.svg',
    image:
      'https://www.allegiantair.com/content/dam/allegiant/images/logos/allegiant-logo-blue.svg',
    foundingDate: '1997-01',
    foundingLocation: {
      '@type': 'Place',
      name: 'Las Vegas, Nevada, US',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '1201 N. Town Center Drive',
      addressLocality: 'Las Vegas',
      addressRegion: 'NV',
      postalCode: '89144',
      addressCountry: 'US',
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'Customer Service',
        telephone: '+1-702-505-8888',
        areaServed: 'US',
        availableLanguage: ['English'],
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Customer Service (Text)',
        telephone: '+1-866-432-6165',
        areaServed: 'US',
        availableLanguage: ['English'],
      },
    ],
    sameAs: [
      'https://www.linkedin.com/company/allegiant-air',
      'https://www.youtube.com/@Allegiant',
      'https://www.facebook.com/allegiant',
      'https://twitter.com/allegiant',
      'https://www.instagram.com/allegiantair',
    ],
    parentOrganization: {
      '@type': 'Organization',
      name: 'Allegiant Travel Company',
    },
    iataCode: 'G4',
    identifier: [
      { '@type': 'PropertyValue', name: 'ICAO', value: 'AAY' },
      { '@type': 'PropertyValue', name: 'Callsign', value: 'ALLEGIANT' },
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': 'https://www.allegiantair.com/#website',
    name: 'Allegiant Air',
    alternateName: 'Allegiant',
    url: 'https://www.allegiantair.com/',
    description:
      'Book low-cost flights and vacation packages with Allegiant Air—save on hotels, rental cars, and more.',
    publisher: {
      '@type': 'Organization',
      '@id': 'https://www.allegiantair.com/#organization',
      name: 'Allegiant Air',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.allegiantair.com/_next/static/images/logo-allegiant-blue-6c59f21a1c23aea493a8a4cad6d0612f.svg',
        width: 150,
        height: 57,
      },
    },
  };

  return { organizationSchema, websiteSchema };
}, []);

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas.organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas.websiteSchema) }}
      />
    </Head>
  );
};

export default JsonLdSchema;
